import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import React from 'react';

import { CloseDialogHandler, Dialog } from '../Dialog';

type Props = {
  open: boolean;
  title: string;
  message: string;
  continueLabel: string;
  backToListLabel: string;
  onContinue: () => void;
  onBackToList: () => void;
};

export const PostSaveDialog: React.FC<Props> = ({
  open,
  title,
  message,
  continueLabel,
  backToListLabel,
  onContinue,
  onBackToList,
}) => {
  const handleClose: CloseDialogHandler = ({ ok }) =>
    (ok ? onBackToList : onContinue)();

  return (
    <Dialog
      open={open}
      title={title}
      titleStartIcon={<CheckCircleIcon sx={{ color: 'success.light' }} />}
      okLabel={backToListLabel}
      cancelLabel={continueLabel}
      onClose={handleClose}
    >
      <div>{message}</div>
    </Dialog>
  );
};
